var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"need-you-help"},[_c('div',{staticClass:"support-link"},[_c('support-icon'),_c('span',[_vm._v("0808 164 3773")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }